import { render } from "./Month.vue?vue&type=template&id=3f32f132&lang=pug"
import script from "./Month.vue?vue&type=script&setup=true&lang=js"
export * from "./Month.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__